import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderEyeOutline = createIcon({
  displayName: 'FolderEyeOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M13.561 18.306c-.32-.485-.32-1.125 0-1.61 .99-1.497 2.544-2.696 4.099-2.696 1.555 0 3.108 1.199 4.099 2.695 .321.485.321 1.126 0 1.61 -.992 1.496-2.545 2.695-4.099 2.695 -1.555.001-3.109-1.198-4.099-2.694Z"></path>
        <path d="M17.776 17.384c.065.065.065.169 0 .234 -.065.065-.169.065-.234 0 -.065-.065-.065-.169 0-.234 .065-.065.17-.065.234 0"></path>
        <path d="M21 11v-3.06c0-1.104-.895-2-2-2h-6.471c-.331 0-.641-.164-.827-.438l-1.405-2.065c-.186-.273-.495-.437-.826-.437h-4.471c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h5"></path>
      </g>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderEye: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderEyeTwoTone} {...props} />

  return <CustomIcon as={FolderEyeOutline} {...props} />
}

export default memo(FolderEye)
